import { FaPlay } from 'react-icons/fa';
import { useState } from 'react';
import { fetchRunBatch } from '../../services/fetchRunBatch';
import { useAppContext } from '../../context/AppContext';

const BatchRange = () => {
    const { token, base_url } = useAppContext();
    const [isOpen, setIsOpen] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [dtc, setDtc] = useState(false);
    const [connector, setConnector] = useState(false);
    const [partner, setPartner] = useState(false);
    const [revenueRecognition, setRevenueRecognition] = useState(false);
    const [instructorBills, setInstructorBills] = useState(false);

    const runBatch = (e) => {
        e.preventDefault();
        fetchRunBatch(token, base_url, {startDate, endDate, dtc, connector, partner, revenueRecognition, instructorBills});
        setSubmitted(true);
        setStartDate("");
        setEndDate("");
        setDtc(false);
        setConnector(false);
        setPartner(false);
        setRevenueRecognition(false);
        setInstructorBills(false);
    }

    const closeModal = () => {
        setIsOpen(false);
        setSubmitted(false);
        setStartDate("");
        setEndDate("");
        setDtc(false);
        setConnector(false);
        setPartner(false);
        setRevenueRecognition(false);
        setInstructorBills(false);
    }

    return (
        <div>
            <button className="btn btn-primary" onClick={() => setIsOpen(true)}><FaPlay/> &nbsp;  Run Batch</button>

            {isOpen && (
                <div className="modal">
                    <div className="modal-container">
                        <h3>{!submitted ? "Let's get your batch running!" : "Batch running..."}</h3>
                        <hr />
                        {!submitted && (
                            <form>
                                <br />
                                <label htmlFor="startDate">Select a Starting Date</label>
                                <input type="date" id="startDate"  value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                                <br />
                                <label htmlFor="endDate">Select an End Date</label>
                                <input type="date" id="endDate"  value={endDate} onChange={(e) => setEndDate(e.target.value)} />

                                <br />
                                <div class="checkbox-container">
                                    <input type="checkbox" id="dtc" checked={dtc} onChange={(e) => setDtc(e.target.checked)} />
                                    <label htmlFor="dtc">Direct Website Enrollments</label>
                                </div>
                                <div class="checkbox-container">
                                    <input type="checkbox" id="connector" checked={connector} onChange={(e) => setConnector(e.target.checked)} />
                                    <label htmlFor="connector">Individual Learner Invoices</label>
                                </div>
                                <div class="checkbox-container">
                                    <input type="checkbox" id="partner" checked={partner} onChange={(e) => setPartner(e.target.checked)} />
                                    <label htmlFor="partner">Group Learner Invoices</label>
                                </div>
                                <div class="checkbox-container">
                                    <input type="checkbox" id="revenueRecognition" checked={revenueRecognition} onChange={(e) => setRevenueRecognition(e.target.checked)} />
                                    <label htmlFor="revenueRecognition">Revenue Recognition</label>
                                </div>
                                <div class="checkbox-container">
                                    <input type="checkbox" id="instructorBills" checked={instructorBills} onChange={(e) => setInstructorBills(e.target.checked)} />
                                    <label htmlFor="instructorBills">Create Instructor Bills</label>
                                </div>
                                <br />
                                <br />
                                <button style={{width: "100%"}} className="btn btn-primary" onClick={runBatch}>Run Batch</button>
                            </form>
                        )}

                        {submitted && (
                            <div>
                                <h5>We will send you an email when the batch is complete!</h5>
                            </div>
                        )}
                        <br />
                        <button style={{width: "100%"}} className="btn btn-secondary" onClick={closeModal}>{!submitted ? "Cancel" : "Close"}</button>
                        
                    </div>
                </div>
            )}
        </div>
    );
};

export default BatchRange;